export const PROFILE_EXPIRATION = "profileExpiration";
export const SIGNED_OUT_LOCATION = "signedOutLocation";

// Refresh cadence was chosen to align with Midway SSO
// https://w.amazon.com/bin/view/NextGenMidway/FAQ#Does_it_take_a_long_time_to_authenticate_using_Yubikey.3F
export const PROFILE_REFRESH_CADENCE = 20; // Hours

export enum COGNITO_AUTHENTICATION_CODES {
  SIGN_IN = "signedIn",
  SIGN_OUT = "signedOut",
  TOKEN_REFRESH = "tokenRefresh",
  TOKEN_REFRESH_FAILURE = "tokenRefresh_failure",
  SIGN_IN_WITH_REDIRECT = "signInWithRedirect",
  SIGN_IN_WITH_REDIRECT_FAILURE = "signInWithRedirect_failure",
  CUSTOM_OAUTH_STATE = "customOAuthState",
}
